import { createAction, props } from '@ngrx/store';
import { ValueHelperState } from '../value-helper-collection.state';

/**
 * Dispatched by `ValueHelperService.init()` before the backend load, to rehydrate the slice
 * from the persisted cache (via the generic persistence layer) so value helpers are available
 * offline.
 */
export const initValueHelpers = createAction('[ValueHelper] Init');

/**
 * Dispatched once the backend value helpers have been loaded (from ValueHelperNgrxService.init()).
 * Populates the slice and triggers a persist of the slice to storage.
 */
export const valueHelpersLoaded = createAction('[ValueHelper] Loaded', props<{ valueHelpers: ValueHelperState[] }>());

/**
 * Dispatched by the persistence bridge with the value helpers read back from storage. Populates
 * the slice like {@link valueHelpersLoaded} but does not trigger a re-persist (the data came
 * from storage).
 */
export const valueHelpersLoadedFromStorage = createAction(
    '[ValueHelper] Loaded from storage',
    props<{ valueHelpers: ValueHelperState[] }>(),
);

/**
 * Dispatched by the load effect when the backend request fails. Transitions the slice to
 * {@link LoadStatus.Error} so the facade's `init()` observable can surface the failure.
 */
export const valueHelpersFailed = createAction('[ValueHelper] Failed');
